import { defineStore } from "pinia";

export const useSuccessMessageStored = defineStore("useSuccessMessageStored", {
  state: () => ({
    messaggioSuccess: null as string | null,
    titoloSuccess: "Success",
    visibleSuccessMessage: false,
    messageType: 'success' as 'success' | 'warning'
  }),
  actions: {
    showSuccess (message: string, title: string = "Successo", type: 'success' | 'warning' = 'success') {
      this.messaggioSuccess = message;
      this.titoloSuccess = title;
      this.messageType = type;
      this.visibleSuccessMessage = true;
    },
    hideSuccess () {
      this.visibleSuccessMessage = false;
    },
    clearSuccess () {
      this.visibleSuccessMessage = false;
      this.titoloSuccess = "Success";
      this.messaggioSuccess = null;
      this.messageType = 'success';
    }
  }
});
